<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

  .new-zz-qc-info-wrap {
    .report_person {
      position: relative;
      z-index: 1;
      height: 170px;
      padding-bottom: 6px;
      padding-left: 20px;
      background: #fafafa;

      &::before {
        position: absolute;
        top: 0;
        left: -24px;
        z-index: -9;
        display: block;
        width: 681px;
        height: 126px;
        background: url('https://pic1.zhuanstatic.com/zhuanzh/1217325a-65a9-433b-af2e-1882ae899435.png?w=681&h=126&t=5&qa=90')
          no-repeat;
        background-size: 100% 126px;
        content: '';
      }

      .person_title {
        .title {
          padding-top: 50px;
          color: #000000;
          font-weight: 600;
          font-size: 54px;
          font-family: PingFangSC-Semibold, PingFang SC;
          line-height: 54px;
        }

        .code {
          margin-top: 28px;
          color: #999999;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 22px;
        }

        .copy-icon {
          position: relative;
          top: 3px;
          width: 24px;
          height: 24px;
          margin-left: 16px;
        }
      }
    }

    .quality-content-luxury {
      padding: 0 32px;
      background: #fff;
      border-radius: 16px;

      .qc-condition {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-top: 32px;

        .condition-left {
          display: flex;
          align-items: center;
          margin-right: 4px;
          color: #111111;
          font-weight: bold;
          font-size: 58px;
          font-family: PingFangSC-Semibold, PingFang SC;
          line-height: 1;
          span {
            display: block;
          }
          .number {
            margin-right: 4px;
            color: #111111;
            font-weight: 500;
            font-size: 64px;
            font-family: Akrobat-ExtraBold, Akrobat;
            line-height: 1;
            letter-spacing: -1px;
          }

          .desc {
            position: relative;
            top: 8px;
            align-self: start;
            color: #111111;
            font-weight: 500;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
          }
        }

        .condition-right {
          position: relative;
          top: 8px;
          display: flex;
          align-self: flex-start;
          box-sizing: border-box;
          color: #999999;
          font-weight: 400;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .qc_result_luxury {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 8px;
        padding-bottom: 20px;
        color: #999;
        font-weight: 400;
        font-size: 24px;

        .detail {
          color: #666666;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 36px;

          &.unfold {
            @include multi-ellipsis(2);
            width: 598px;
          }

          .name {
            @include border-1px(#bbbbbb, 4px);
            box-sizing: border-box;
            height: 28px;
            margin: 0 12px 0 0;
            padding: 0 8px;
            color: #111111;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
          }

          .stow {
            position: relative;
            margin-left: 20px;
            color: #666666;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;

            &::before {
              position: absolute;
              top: 0;
              left: 0;
              min-width: 200%;
              height: 200%;
              border-bottom: 1px solid #666;
              -webkit-transform: scale(0.5);
              transform: scale(0.5);
              -webkit-transform-origin: 0 0;
              transform-origin: 0 0;
              content: '';
            }
          }
        }

        .text-unfold {
          position: relative;
          top: -8px;
          align-self: flex-end;
          padding-bottom: 2px;
          color: #666666;
          font-weight: 300;
          font-size: 20px;
          font-family: PingFangSC-Light, PingFang SC;
          white-space: nowrap;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 200%;
            height: 200%;
            border-bottom: 1px solid #666;
            -webkit-transform: scale(0.5);
            transform: scale(0.5);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            content: '';
          }
        }
      }

      .qc-info {
        .info {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          box-sizing: border-box;
          width: 598px;

          .luxury-detail-item {
            position: relative;
            display: flex;
            flex: 0 0 298px;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            box-sizing: border-box;
            height: 144px;
            padding: 28px 0;
            &:nth-of-type(odd) {
              padding-right: 11px;
            }
            &:nth-of-type(even) {
              padding-left: 11px;
            }
            &::after {
              @include hairline(#f0f0f0);
              border-bottom-width: 1px;
            }

            &::before {
              border: none !important;
            }

            .luxury-value {
              display: -webkit-box;
              align-items: center;
              max-width: 282px;
              height: 56px;
              overflow: hidden;
              color: #111;
              font-weight: bold;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              line-height: 30px;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }

            .luxury-key {
              display: flex;
              align-items: center;
              height: 24px;
              color: #999;
              font-weight: 400;
              font-size: 20px;
              font-family: PingFangSC-Light, PingFang SC;
              line-height: 1;
              text-overflow: ellipsis;

              .tips {
                position: relative;
                top: 1px;
                margin-left: 8px;

                .z-tip-trigger {
                  display: flex;
                }

                img {
                  width: 20px;
                  height: 20px;
                }
              }
              .specifications {
                position: relative;
                top: 1px;
                width: 20px;
                height: 20px;
                margin-left: 4px;
                color: #999999;
                font-size: 20px;
                vertical-align: baseline;
              }
            }
          }
          .luxury-detail-item:last-child {
            width: 100%;
          }

          .luxury-detail-item:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="new-zz-qc-info-wrap">
    <div class="quality-content-luxury">
      <div class="qc-condition">
        <div class="condition-left" @click="toggleConditionPopup">
          <!-- <span v-if="gradeMap.num" class="number">{{ gradeMap.num }}</span> -->
          <span class="number">{{ gradeMap.number }}</span>
          <span class="desc">{{ gradeMap.desc }}</span>
        </div>
        <div v-if="!iszzT" class="condition-right" @click="toggleConditionPopup">
          <img
            :src="
              $setPicSize(
                'https://pic5.zhuanstatic.com/zhuanzh/9e5aa5b8-343a-4836-9a1e-52cffb608082.png'
              )
            "
          />
        </div>
      </div>

      <div v-if="descInfo" class="qc_result_luxury">
        <p id="detail" class="detail" :class="{ unfold: !unfold }">
          <span class="name">检测结果</span>{{ descInfo }}
          <span v-if="twoRowFlag && unfold" class="stow" @click="onUnfold">收起</span>
        </p>
        <span v-if="twoRowFlag && !unfold" class="text-unfold" @click="onUnfold">展开</span>
      </div>

      <div class="qc-info">
        <div v-if="nineParams" class="info">
          <div v-for="(item, index) in nineParams" :key="index" class="luxury-detail-item">
            <div class="luxury-value">
              {{ item.value }}
            </div>
            <p class="luxury-key" @click="specificationsClick(item)">
              {{ item.name }}
              <span>
                <img
                  v-if="item.hasWiki && !iszzT"
                  class="specifications"
                  :src="
                    $setPicSize(
                      'https://pic3.zhuanstatic.com/zhuanzh/280e9ecd-2f3c-444b-a7a7-5a832773342c.png',
                      30,
                      30
                    )
                  "
                />
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  import native from '@zz-common/native-adapter'
  import { setPicSize } from '@zz-common/zz-utils'
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {}
      },
      config: {
        type: Object,
        default: () => {}
      },
      qualityInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        unfold: false,
        intervalFlag: null,
        twoRowFlag: false,
      }
    },
    computed: {
      $setPicSize(){
        return setPicSize
      },
      iszzT(){
        return native.in('zztong')
      },
      // 匹配数据拆分num和汉字
      gradeMap() {
        let desc = ''
        let number = ''
        let { infoLv } = this.dataInfo
        // 订单快照页面进入质检报告场景
        if (!infoLv || Object.keys(infoLv).length == 0) {
          const { finenessDialogContents = [], finenessLevelValueId = '' } =
            this.dataInfo.conditionIntro || {}
          // "infoLv": { "level": "95新", "summary": "轻微使用痕迹，功能完好" },
          const info = (finenessDialogContents || []).find(
            ({ valueId }) => valueId === finenessLevelValueId
          )
          infoLv = {
            level: info && info.finenessName ? info.finenessName : '',
          }
        }
        if (infoLv && infoLv.level) {
          number = this.formatVal(infoLv.level).ms1
          desc = this.formatVal(infoLv.level).ms2
        }
        return {
          desc,
          number
        }
      },
      nineParams() {
        return (
            this.dataInfo?.luxuryReport?.fixLabels && this.dataInfo.luxuryReport.fixLabels.filter((it) => it.value)
          )
      },
      descInfo() {
        return `${this.dataInfo?.luxuryReport?.checkDesc || ''}`
      }
    },
    methods: {
      toggleConditionPopup() {
        this.$emit('toggle')
      },
      onUnfold() {
        this.unfold = !this.unfold
      },
      /**
       * $ 二奢参数规格点击事件
       * specificationsClick(item) {
       */
      // TODO: 二奢融合
      specificationsClick({ checkId }) {
        // 转转通场景不允许弹出
        if(this.iszzT)  return
        this.$emit('openPopupWarchPedia', checkId)
      },
      formatVal(params) {
        if (!params) return
        const reg1 = /\d+/g
        const result = params.match(reg1)
        const ms1 = result ? result[0] : undefined
        const reg2 = /[\u4e00-\u9fa5]/g
        const ms2 = params.match(reg2).join('')
        // 返回瑕疵的时候
        if (!ms1 && ms2) {
          if (ms2.indexOf('全新') > -1) {
            return { ms1: ms2.substring(0, 2), ms2: ms2.substring(2) }
          }
          return { ms1: ms2, ms2: '' }
        }
        return { ms1, ms2 }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.intervalFlag = setInterval(() => {
          try {
            if (document.querySelector('#detail')) {
              // @ts-ignore
              const titleClient = document.querySelector('#detail')?.clientHeight || 0
              const titleScroll = document.querySelector('#detail')?.scrollHeight || 0
              if (titleScroll > titleClient) {
                this.twoRowFlag = true
                if (this.intervalFlag) clearInterval(this.intervalFlag)
              }
            }
          } catch (e) {
            //
          }
        }, 200)
      })
    }
  }
</script>
